import React, { useState, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const RECAPTCHA_KEY = process.env.GATSBY_SITE_RECAPTCHA_KEY;

const CaptchaTextReveal = ({ hiddenText, langKey = "en" }) => {
  const [verified, setVerified] = useState(false);
  const [error, setError] = useState("");
  const recaptchaRef = useRef();

  const handleRecaptcha = async (token) => {
    if (!token) {
      setError("Please verify that you are not a robot!");
      return;
    }

    // Verify the token server-side
    const res = await fetch("/.netlify/functions/verify-recaptcha", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    });

    const result = await res.json();
    console.log(result.verifyResponse.success)
    if (result.verifyResponse.success) {
      setVerified(true);
      setError("");
    } else {
      setError("Captcha verification failed. Please try again.");
      recaptchaRef.current.reset();
    }
  };

  return (
    <div style={{ textAlign: "center", marginTop: "1.5rem" }}>
      {!verified ? (
        <>
          <p
            style={{
              background: "#f5f5f5",
              padding: "1rem",
              borderRadius: "10px",
              color: "#999",
              fontStyle: "italic",
            }}
          >
            [Phone Number hidden — please complete the CAPTCHA to view it]
          </p>
          <div style={{ marginTop: "1rem" }}>
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey={RECAPTCHA_KEY}
              onChange={handleRecaptcha}
              hl={langKey}
            />
          </div>
          {error && (
            <p style={{ color: "red", marginTop: "0.5rem" }}>{error}</p>
          )}
        </>
      ) : (
        <div
          style={{
            background: "#e6ffe6",
            padding: "1rem",
            borderRadius: "10px",
            color: "#333",
            fontWeight: "bold",
            transition: "opacity 0.3s ease-in-out",
          }}
        >
          {hiddenText}
        </div>
      )}
    </div>
  );
};

export default CaptchaTextReveal;
